import { render } from "./Horizontal.vue?vue&type=template&id=7841bad8"
import script from "./Horizontal.vue?vue&type=script&lang=ts"
export * from "./Horizontal.vue?vue&type=script&lang=ts"
script.render = render

export default script